import { render, staticRenderFns } from "./AgendarAtencion.vue?vue&type=template&id=66f77a63&scoped=true&"
import script from "./AgendarAtencion.vue?vue&type=script&lang=js&"
export * from "./AgendarAtencion.vue?vue&type=script&lang=js&"
import style0 from "./AgendarAtencion.vue?vue&type=style&index=0&id=66f77a63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f77a63",
  null
  
)

export default component.exports